// extracted by mini-css-extract-plugin
export var contactRow = "ContactsSection-module--contactRow--241a6";
export var container = "ContactsSection-module--container--d4e24";
export var header = "ContactsSection-module--header--53326";
export var mapFrame = "ContactsSection-module--mapFrame--2de06";
export var officeAddress = "ContactsSection-module--officeAddress--da1be";
export var officeCard = "ContactsSection-module--officeCard--48846";
export var officeCity = "ContactsSection-module--officeCity--4d224";
export var officeCountry = "ContactsSection-module--officeCountry--9ea9e";
export var officeInfo = "ContactsSection-module--officeInfo--d859b";
export var officesGrid = "ContactsSection-module--officesGrid--894fe";
export var section = "ContactsSection-module--section--8d6c8";
export var tag = "ContactsSection-module--tag--8d0b4";
export var title = "ContactsSection-module--title--1d1ac";